import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { getZonePhotoUrl } from '../../api';
import type { Zone } from '../../types';

interface ZonePhotoThumbnailProps {
  zone: Zone;
  className?: string;
  alt?: string;
}

export function ZonePhotoThumbnail({
  zone,
  className,
  alt = '',
}: ZonePhotoThumbnailProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [zone.id, zone.photo_storage_path]);

  if (!zone.photo_storage_path || hasError) {
    return null;
  }

  return (
    <img
      src={getZonePhotoUrl(zone.id)}
      alt={alt}
      className={cn('shrink-0 object-cover', className)}
      onError={() => setHasError(true)}
    />
  );
}
